import {useCallback, useEffect, useRef} from "react";
import {call, delay} from 'redux-saga/effects';

import {useSagaCallback} from "../store/sagas";
import {useRecaptcha} from "../utils/recaptcha";
import CancelTokenSource from "../utils/cancel";
import {apiPostWithCaptcha} from './client';

export function* createPost(data, recaptcha) {
    const url = `/api/v2/action/create_post`;
    const result = yield call(apiPostWithCaptcha, url, data, recaptcha);
    yield delay(1000);
    return result;
}

export const useCreatePost = (feedbackCh) => {
    const recaptcha = useRecaptcha();
    const cancelSourceRef = useRef(() => new CancelTokenSource());
    useEffect(() => {
        return cancelSourceRef.current?.cancel;
    }, [cancelSourceRef]);
    return useSagaCallback(feedbackCh, useCallback(function* (post) {
        return yield call(createPost, post, recaptcha);
    }, [recaptcha]), cancelSourceRef.current.token);
};
